export default "/assets/images/the-critter-cuddler.c483d2ce79a312bd.jpg";